export default {
      id: "icon--what-to-wear-usage",
      viewBox: "0 0 32 31.6",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--what-to-wear-usage",
      toString: function () {
        return this.url;
      }
    }